import {configureStore} from "@reduxjs/toolkit";
import createSagaMiddleware from 'redux-saga';
import {persistReducer, persistStore} from 'redux-persist'
import storage from 'redux-persist/lib/storage';
import {createBrowserHistory} from 'history';
import {createReduxHistoryContext} from "redux-first-history";
import {createRootReducer} from '../reducers';
import {rootSaga} from "../saga";
import { normalizePaginationLimit } from "../common/constants/pagination";

const migratePersistedState = async (state) => {
  if (!state) {
    return state;
  }

  return {
    ...state,
    calculs: state.calculs
      ? {
          ...state.calculs,
          limit: normalizePaginationLimit(state.calculs.limit),
        }
      : state.calculs,
    folders: state.folders
      ? {
          ...state.folders,
          limit: normalizePaginationLimit(state.folders.limit),
          folderCalculsLimit: normalizePaginationLimit(
            state.folders.folderCalculsLimit,
          ),
        }
      : state.folders,
  };
};

const persistConfig = {
  key: 'root',
  version: 1,
  migrate: migratePersistedState,
  storage,
  blacklist: ['loader', 'router', 'context']
};

const {createReduxHistory, routerMiddleware} = createReduxHistoryContext({history: createBrowserHistory()});
const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: persistReducer(persistConfig, createRootReducer),
  middleware: [routerMiddleware, sagaMiddleware],
});

sagaMiddleware.run(rootSaga);
export const persistor = persistStore(store);
export const history = createReduxHistory(store);
